
export class RoundCompleteEvent {
	scheduleIds: number[] = [];
	message: string = '';
}